import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { CalendarCheck } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const FloatingBook = () => {
  const { t } = useLang();
  const { pathname } = useLocation();
  if (pathname === "/book" || pathname.startsWith("/admin")) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-5 right-5 z-40"
    >
      <Link
        to="/book"
        data-testid="floating-book-button"
        className="inline-flex items-center gap-2 bg-pine text-bone font-semibold text-sm px-6 py-4 rounded-full shadow-[0_12px_36px_rgba(11,47,47,0.38)] hover:bg-pine-500 transition-colors duration-300"
      >
        <CalendarCheck size={17} />
        {t("nav_book")}
      </Link>
    </motion.div>
  );
};

export default FloatingBook;
